import { BaseApi } from '@bv/api';

class ConversationsApi extends BaseApi {
  constructor() {
    super('conversations');
  }

  public async uploadFile(formData: FormData, resource: string, config = {}) {
    return this.request({
      method: 'post',
      url: resource,
      data: formData,
      ...config,
    });
  }
  public async getFile(fileId: string, config = {}) {
    return this.request({
      method: 'get',
      url: `files/${fileId}/presigned-url`,
      ...config,
    });
  }
}

export default new ConversationsApi();
